<template>
  <div>
    <div class="header-wrapper">
      <div class="header-title">
        ONBOARDING PROCCESS
      </div>
    </div>
    <div
      class="row"
    >
      <div class="col-12 d-flex justify-content-center">
        <z-card
          class="onboarding-card"
        >
          <div
            v-if="!isRejected"
            class="row"
          >
            <div class="col-12">
              <h2>
                STEP 4
              </h2>
              <div class="sub-title">
                Your application has been sent for review
              </div>
            </div>
          </div>

          <div class="row">
            <div
              class="col-12 text-center"
              v-html="message"
            />
          </div>

          <div class="row">
            <div class="col-12 text-center">
              You can also contact us via:
            </div>
            <div class="col-12 d-flex justify-content-center">
              <ul class="contact-list">
                <li>
                  <a
                    href="https://discord.gg/zeyplay"
                    target="_blank"
                  >
                    <i class="icon icon-contact-discord" />
                  </a>
                </li>
                <li>
                  <a
                    href="mailto:applications@zeyplay.com"
                    target="_blank"
                  >
                    <i class="icon icon-contact-email" />
                  </a>
                </li>
                <li>
                  <a
                    href="https://t.me/zeyplay"
                    target="_blank"
                  ><i class="icon icon-contact-telegram" /></a>
                </li>
                <li>
                  <a
                    href="https://vk.com/zeyplay"
                    target="_blank"
                  >
                    <i class="icon icon-contact-vk" />
                  </a>
                </li>
                <li>
                  <a
                    href="https://wa.me/message/O3RYYFUIBEJZK1"
                    target="_blank"
                  >
                    <i class="icon icon-contact-whatsapp" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </z-card>
      </div>
    </div>
  </div>
</template>

<script>
import ZCard from '@/components/shared/ZCard.vue';

export default {
  components: {
    ZCard,
  },

  computed: {
    isRejected() {
      return this.$store.getters.boardingRejected;
    },

    message() {
      let text = '';

      if (this.$store.getters.boardingPending) {
        text = `Thank you for joining us! We will consider your application as soon as
          possible and we will contact you if we have any questions.
          <div class="mt-2">
            You can contact our Quality Manager to speed
            up your review - Discord ID: <span style="font-family: var(--font-bold); color: var(--color-secondary);">ZeyPlay#0001</span>
          </div>
        `;
      }

      if (this.$store.getters.boardingRejected) {
        text = 'Your application has been rejected.  If you have any questions, please contact us.';
      }

      return text;
    },
  },

  created() {
    if (this.$store.getters.isApproved) {
      this.$router.push('/');
    }
  },
};
</script>

<style lang="scss" scoped>
.header-wrapper {
  position: relative;
  height: 180px;
  background-image: url('/img/header-bg.jpg');
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;

  .header-title {
    text-align: center;
    z-index: 2;
    font-family: var(--font-bold);
    font-size: 34px;
    text-transform: uppercase;
    color: #fff;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    background: linear-gradient(271.62deg, rgba(225, 81, 0, 0.8) 0.84%, rgba(255, 135, 0, 0.8) 99.32%);
  }
}

.icon-contact-vk {
  font-size: 22px;
  position: relative;
  top: 3px;
  left: 0px;
}

.icon-contact-whatsapp {
  font-size: 18px;
  position: relative;
  top: 2px;
  left: 1px;
}

.onboarding-card {
  position: relative;
  overflow: hidden;
  margin-top: 30px;
  max-width: 750px;
  padding: 30px;
  padding-bottom: 30px;
  width: 100%;

  h2 {
    width: 100%;
    text-align: center;
    color: var(--color-secondary);
    font-family: var(--font-bold);
    font-size: 24px;
    padding: 0;
    margin: 0;
  }

  .sub-title {
    margin-top: 3px;
    text-align: center;
    font-size: 16px;
    text-transform: uppercase;
    color: #fff;
    font-family: var(--font-medium);
  }
}

.discord-id {
    font-family: var(--font-bold); color: var(--color-secondary);
  }

.contact-list {
  margin: 0 auto;
  display: flex;
  list-style: none;

  a {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    background: var(--color-blue-100);
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 3px;
    transition: 0.2s;

    &:hover {
      text-decoration: none;
      background: var(--color-blue-text);

      .icon {
        color: var(--color-white);
        opacity: 0.9;
      }
    }
  }

  .icon {
    color: #fff;
    opacity: 0.7;
    transition: 0.2s;
  }
}

@media screen and (max-width: 767px) {
  .header-wrapper {
    height: 80px;

    .header-title {
      font-family: var(--font-bold);
      font-size: 20px;
    }

    img {
      height: 60px;
    }
  }
}
</style>
